// tslint:disable-next-line:max-classes-per-file
export class ListFilterItem {
    public title: string;
    public icon: string;
    public selected: boolean;
    constructor(title: string, icon?: string, selected?: boolean) {
        this.title = title;
        this.icon = icon || '';
        this.selected = selected || false;
    }
}
// tslint:disable-next-line:max-classes-per-file
export class ListSortOrderItem {
    public title: string;
    public icon: string;
    public order: number; // 1 = Assending (low to high) , -1 = Decending (high to low)
    public selected: boolean;
    constructor(title: string, icon?: string, order?: number, selected?: boolean) {
        this.title = title;
        this.icon = icon || '';
        this.order = order || 1;
        this.selected = selected || false;
    }
}
